import { getIconSrc, type IconName } from '../../design-system/icons/iconPaths';

/**
 * Leading icon for a facet-suggestion row (SRP Autocomplete, the navbar fallback launcher and
 * the static launcher script all share this one table so the three dropdowns can never
 * disagree). `companyId` rows render the company's logo instead, this is only their fallback
 * once the hosted logo fails to load.
 */
const FACET_SUGGESTION_ICON: Record<string, IconName> = {
  location: 'mapPin',
  regionTags: 'mapPin',
  companyId: 'buildingOffice2',
  companyIndustry: 'buildingOffice2',
  normalisedTitle: 'briefcase',
  jobType: 'briefcase',
  normalisedRoleLevel: 'chartBar',
  peopleManagementTier: 'chartBar',
  educationLevel: 'chartBar',
  field: 'squares2x2',
  skillsAndTechnologies: 'sparkles',
  requiredLanguages: 'globeAlt',
  remoteness: 'wifi',
  benefits: 'checkCircle',
};

const DEFAULT_ICON: IconName = 'funnel';

export function getFacetSuggestionIconName(attribute: string): IconName {
  return FACET_SUGGESTION_ICON[attribute] ?? DEFAULT_ICON;
}

/** Public SVG URL for the row icon, for surfaces that render plain HTML (the static launcher). */
export function getFacetSuggestionIconSrc(attribute: string): string {
  return getIconSrc(getFacetSuggestionIconName(attribute), 'outline');
}

/** attribute -> icon URL for every attribute in the table, for baking into a static script. */
export function buildFacetSuggestionIconSrcMap(): Record<string, string> {
  const out: Record<string, string> = {};
  Object.keys(FACET_SUGGESTION_ICON).forEach((attribute) => {
    out[attribute] = getFacetSuggestionIconSrc(attribute);
  });
  out.__default = getIconSrc(DEFAULT_ICON, 'outline');
  return out;
}
